import { z } from "zod";

import { useFormWithZod } from "@/hooks/useFormWithZod";

const schema = () =>
  z.object({
    id: z.string().optional(),
    name: z.string(),
    label: z
      .string({ required_error: "Label is required" })
      .min(1, "Label is required"),
    type: z
      .string({ required_error: "Type is required" })
      .min(1, "Type is required"),
    show_in_client_mapping: z.boolean().optional().nullable(),
  });

export type CustomFieldsFormModel = z.infer<ReturnType<typeof schema>>;

export const useCustomFieldsForm = () => {
  const customFieldsFormTypeSchema = schema();
  const { form, rule } = useFormWithZod(customFieldsFormTypeSchema);
  return { form, rule, schema: customFieldsFormTypeSchema };
};
